import React from "react";
import {Box, Heading, Form, FormField, TextInput, Text, Button, Layer, DateInput} from "grommet";
import { useMutation } from '@apollo/client';
import {UPSERT_MOVEMENT, UPSERT_PRODUCT} from "./ProductGQL.jsx";
import {colors, buttonStyles, layerStyles} from "../../utilis/theme.js";
import AlertDialog from "../common/AlertDialog.jsx";

export default function AddMovement(props) {

  const [formData,setFormData]=React.useState({product:props?.prodSel?.id,user:sessionStorage.getItem("userId"),data:new Date().toISOString()});
  const [mutationAddMovement]=useMutation(UPSERT_MOVEMENT);
  const [alertDialog, setAlertDialog] = React.useState({open: false, message: "", type: "success"});



  const onChangeTextInput=(event)=>{
      if(event.target.name==="quantity") {
          setFormData({...formData, [event.target.name]: parseFloat(event.target.value)})
      }else{
          setFormData({...formData, [event.target.name]: event.target.value})
      }
  }

  function onUpsertMovement(){
      let formDataApp={...formData};
      if(formDataApp?.quantity){
            if(props.movementType==="carico"){
              let quantity= parseFloat(formDataApp["quantity"])
              formDataApp["quantity"] = quantity>=0? quantity : -quantity //Se è minore di zero moltiplico per -1
          }else{
              let quantity= parseFloat(formDataApp["quantity"])
              formDataApp["quantity"] = quantity<0 ? quantity : -quantity //Se è maggiore di zero moltiplico per -1
          }
        mutationAddMovement({variables: formDataApp})
        .then((value)=>{
          if(props.getProducts){
              props.getProducts();
          }
          setAlertDialog({open: true, message: "Movimento aggiunto correttamente", type: "success"});
        }).catch((value)=>{
            console.error(value);
          setAlertDialog({open: true, message: "Errore durante l'operazione", type: "error"});
        })
      }
  }

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }



  return (
    <>
      <Layer onEsc={() => { if(!alertDialog.open) onEscLayer(); }} onClickOutside={() => { if(!alertDialog.open) onEscLayer(); }} style={layerStyles.dialog}>
          <Box round="16px" pad="medium" direction="column" background="white" align="center" overflow="auto">
              <Heading level="2" margin="none" size="small">
                <Box direction="row" gap="large">
                    {`Inserisci Movimento di ${props.movementType}`}
                  {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Lavoro.csv"} style={{width:'200px',fontSize:'20px',background:'#397aa3',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button> */}
                </Box>
              </Heading>
              <Box fill gap="medium" pad={{ vertical: "small" }}>
                <Form>
                  <Box pad="xsmall">
                        <FormField required label="Data">
                            <DateInput
                              format="dd/mm/yyyy"
                              value={formData?.data}
                              onChange={({ value }) => {
                                // Creo un oggetto Data dalla stringa
                                let date = new Date(value);
                                const currentHours = new Date().getHours();
                                const currentMinutes = new Date().getMinutes();

                                date.setHours(currentHours);
                                date.setMinutes(currentMinutes);
                                console.log(date.toISOString());
                                setFormData({...formData,data: date.toISOString()})}}
                            />
                        </FormField>
                        <FormField required label={props.movementType==="carico"? "Quantità da aggiungere": "Quantità da rimuovere"}>
                          <Box direction="row" align="center">
                            <TextInput
                                type={"number"}
                              name="quantity"
                              value={ formData?.quantity }
                              onChange={e => onChangeTextInput(e)}
                            />
                            {props.prodSel?.um && (
                              <Text margin={{left:'small'}} weight="bold" color={colors.primary} style={{whiteSpace:'nowrap'}}>{props.prodSel.um}</Text>
                            )}
                          </Box>
                        </FormField>
                        {props.prodSel?.ppu > 0 && (
                          <Text size="small" color={formData?.quantity > 0 ? colors.textSecondary : colors.textDisabled} margin={{top:'xsmall'}}>
                            Costo movimento: {formData?.quantity > 0
                              ? <Text size="small" weight="bold" color={colors.primary}>{`€ ${(formData.quantity * props.prodSel.ppu).toFixed(2)}`}</Text>
                              : <Text size="small" color={colors.textDisabled}>{`€ 0.00`}</Text>
                            }
                          </Text>
                        )}
                  </Box>
                </Form>

                <Box direction="row" gap="medium" alignSelf="end" >
                  <Button margin="small" label= {!props.product?"Aggiungi":"Aggiorna"} onClick={onUpsertMovement} style={buttonStyles.primary}/>
                </Box>
              </Box>
            </Box>
      </Layer>
      <AlertDialog
          open={alertDialog.open}
          onClose={() => {
              setAlertDialog({open: false, message: "", type: "success"});
              if(alertDialog.type === "success") onEscLayer();
          }}
          message={alertDialog.message}
          type={alertDialog.type}
      />
    </>
  )
}